"use strict";
/* VARIABLES */
Object.defineProperty(exports, "__esModule", { value: true });
const escapeRe = /[\\^$.*+?()[\]{}|]/g;
const isNativeRe = new RegExp(`^${Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(escapeRe, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?')}$`);
/* IS NATIVE */
const isNative = (x) => {
    return isNativeRe.test(x.toString());
};
/* EXPORT */
exports.default = isNative;
